<template>
	<div class="task-view" :class="$vuetify.breakpoint.smAndDown ? 'px-2':'px-4'">
		<template v-if="!$vuetify.breakpoint.smAndDown">
			<div class="task-view-items">
				<v-btn v-if="isTasklist" depressed color="#00AAFD" class="ml-2 mr-2 white--text text-capitalize" @click="$emit('new-search')">
					<span>New Task list</span>
				</v-btn>
				<v-btn depressed :text="isTasklist" color="#00AAFD" class="" :class="isTasklist ? 'text-capitalize':'text-capitalize white--text'"  @click="onCreate()">
					<v-icon :color="isTasklist ? '#00AAFD':'#FFFFFF'" class="mr-1">mdi-plus</v-icon>
					Create
				</v-btn>
			</div>
			<div class="task-view-items">
				<v-btn-toggle
					v-model="toggle_exclusive"
					:color="color"
					:style="{ boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)' }"
					background-color="#FFFFFF"
					borderless
					dense
					mandatory
					@change="$emit('switch')"
				>
					<v-btn class="text-capitalize" color="#FAFAFA">
						<CalendarIcon class="mr-1" width="20" height="20" :color="toggle_exclusive === 0 ? color:'rgba(0, 0, 0, 0.54)'"/>
						<span style="opacity: 0.7;">Calendar</span>
					</v-btn>
					<v-btn class="text-capitalize" color="#FFFFFF">
						<v-icon size="20" :color="toggle_exclusive === 1 ? color:'rgba(0, 0, 0, 0.54)'">mdi-format-list-bulleted</v-icon>
						<span style="opacity: 0.7;" class="mx-1">List</span>
					</v-btn>
				</v-btn-toggle>
				<v-select
					v-if="!$vuetify.breakpoint.smAndDown && isTasklist"
					class="mx-4"
					style="width: 180px"
					v-model="select_status"
					:items="statuses"
					append-icon="mdi-chevron-down"
					:menu-props="{ bottom: true, offsetY: true}"
					color="rgba(25, 42, 62, 0.7)"
					background-color="#FAFAFA"
					item-color="white"
					solo
					dense
					hide-details
					multiple
					return-object
				>
					<template v-slot:selection="{ index, item }">
						<div v-if="index === 0" style="width: 99%">
							<div>
								<span v-if="select_status.length === 2" style="padding-top: 2px;color: rgba(25, 42, 62, 0.7)">All tasks</span>
								<span v-else style="padding-top: 2px;color: rgba(25, 42, 62, 0.7)">{{ item.text }}</span>
							</div>
						</div>
					</template>
					<template v-slot:item="{item, on, attrs}">
						<v-list-item v-on="on">
							<v-simple-checkbox
								:value="attrs.inputValue"
								:ripple="false"
								:color="color"
								v-on="on"
								dense
								:disabled="item.value === 'recurring'"
							></v-simple-checkbox>
							<span class="checkbox-text ml-4"> {{ item.text }}</span>
						</v-list-item>
					</template>
				</v-select>
				<v-menu v-if="!$vuetify.breakpoint.smAndDown && isTasklist" offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							:style="isColumnDiff ? `border: 1px solid ${color}`:''"
							class="text-capitalize"
							color="#FAFAFA"
							v-bind="attrs"
							v-on="on"
							@click="is_down = !is_down"
						>
							<ColumnsTable :color="'#82899B'" width="20" height="20" class="mr-2"/>
							<span class="mr-2" style="color: rgba(25, 42, 62, 0.7)">Columns</span>
							<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
							<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
						</v-btn>
					</template>
					<div style="height: 68vh; background-color: white;">
						<div class="tree-wrap">
							<v-draggable v-model="customise_view" class="tree-wrap-container" style="background-color: white" @change="onChange($event)">
								<transition-group>
									<div v-for="item in customise_view" :key="item.value" >
										<v-list-item dense>
											<DragIcon class="checkbox-text-hover" :color="color" width="20" height="20"/>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="select_customise_view"
												:label="item.text"
												:value="item"
												:color="color"
												dense
												hide-details
											></v-checkbox>
										</v-list-item>
									</div>
								</transition-group>
							</v-draggable>
						</div>
					</div>
				</v-menu>
				<v-select
					v-if="!$vuetify.breakpoint.smAndDown && !isTasklist"
					class="mx-4"
					style="width: 150px"
					v-model="select_types"
					:color="color"
					background-color="#FAFAFA"
					:items="dayOfType"
					item-color="success"
					append-icon="mdi-chevron-down"
					:menu-props="{ bottom: true, offsetY: true}"
					solo
					dense
					hide-details
				>
				</v-select>
				<v-select
					v-if="!$vuetify.breakpoint.smAndDown && !isTasklist"
					style="width: 180px"
					v-model="select_view_options"
					:color="color"
					background-color="#FAFAFA"
					:items="viewOptions"
					item-color="success"
					label="View Options"
					append-icon="mdi-chevron-down"
					:menu-props="{ bottom: true, offsetY: true}"
					solo
					dense
					hide-details
					return-object
					multiple
				>
					<template v-slot:selection="{ index }">
						<span style="padding-top: 2px" v-if="index === 0">View Options</span>
						<span v-if="index === 1"></span>
					</template>
					<template v-slot:item="{item, on, attrs}">
						<v-list-item v-on="on">
							<v-simple-checkbox
								:value="attrs.inputValue"
								:ripple="false"
								v-on="on"
								:color="color"
								dense
							></v-simple-checkbox>
							<span class="checkbox-text ml-4"> {{ item.text }}</span>
						</v-list-item>
					</template>
				</v-select>
			</div>
		</template>
		<template v-if="$vuetify.breakpoint.smAndDown">
			<div>
				<v-btn depressed v-if="isTasklist" color="#00AAFD" class="white--text text-capitalize" @click="$emit('new-search')">
					<span v-if="$vuetify.breakpoint.smAndDown">Search</span>
				</v-btn>
				<v-btn v-if="!isTasklist" class="text-capitalize" color="#FAFAFA" @click="$emit('data-picker')">
					<CalendarTeamIcon color="rgba(0, 0, 0, 0.54)" width="20" height="20" class="mr-1"/>
					<span style="color: rgba(25, 42, 62, 0.7)">All Calendars</span>
				</v-btn>
			</div>
			<div>
				<v-btn-toggle
					v-model="toggle_exclusive"
					:color="color"
					:style="{ boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)' }"
					background-color="#FFFFFF"
					borderless
					dense
					mandatory
					@change="$emit('switch')"
				>
					<v-btn class="text-capitalize" color="#FAFAFA">
						<CalendarIcon class="mr-1" width="20" height="20" :color="toggle_exclusive === 0 ? color:'rgba(0, 0, 0, 0.54)'"/>
						<span>Calendar</span>
					</v-btn>
					<v-btn class="text-capitalize" color="#FFFFFF">
						<v-icon size="20" :color="toggle_exclusive === 1 ? color:'rgba(0, 0, 0, 0.54)'">mdi-format-list-bulleted</v-icon>
						<span class="mx-1">List</span>
					</v-btn>
				</v-btn-toggle>
			</div>
		</template>
	</div>
</template>
<script>
import CalendarIcon from "@/components/icons/calendar";
import ColumnsTable from "@/components/icons/columns_table.vue";
import CalendarTeamIcon from "@/components/icons/calendar_team";
import DragIcon from "@/components/icons/drag.vue";
import config from "@/config.js";

const CREATE_ITEMS = config.create_items;

const TASK_STATUS = [
	{ text: 'Incomplete tasks', value: config.task_incomplete },
	{ text: 'Completed tasks', value: config.task_completed },
];

/* the user will be able to create and amend tasks */
const TR = 'TR'; 
/* the user will be able to enter and amend Items Charges */
const CH = 'CH';
/* If selected the user can manage public holidays */
const DPubHol = 'DPubHol';

export default {
	name: 'TaskView',
	props: {
		color: {
			type: String,
			default: ''
		},
		viewOptions: {
			type: Array,
			default: () => []
		},
		dayOfType: {
			type: Array,
			default: () => []
		},
		statusesInit: {
			type: Array,
			default: () => []
		},
		customiseInit: {
			type: Array,
			default: () => []
		},
		typesInit: {
			type: String,
			default: 'week'
		},
		viewOptionsInit: {
			type: Array,
			default: () => [],
		},
		isTasklist: {
			type: Boolean,
			default: true
		},
	},
	components: {
		CalendarIcon,
		ColumnsTable,
		CalendarTeamIcon,
		DragIcon
	},
	data() {
		return {
			toggle_exclusive: this.isTasklist ? 1 : 0,
			is_down: true,
			statuses: TASK_STATUS,
			customise_view: this.customiseInit.filter(head => {return head.value !== 'select' && head.value !== 'drag'}),
			select_status: this.statusesInit,
			select_customise_view: this.customiseInit.filter(head => {return head.value !== 'select' && head.value !== 'drag'}),
			
			select_types: this.typesInit,
			select_view_options: this.viewOptionsInit
		}
	},
	watch: {
		statusesInit() {
			this.select_status = this.statusesInit;
		},
		customiseInit() {
			const customise_init = this.customiseInit.filter(head => {return head.value !== 'select' && head.value !== 'drag'});
			const task_head_init = config.task_head.filter(head => {return head.value !== 'select' && head.value !== 'drag'});
			
			if (customise_init.length === task_head_init.length) {
				this.customise_view = customise_init;
				this.select_customise_view = this.customise_view.filter(head => {return head.showable === true });
			}
			if (customise_init.length < task_head_init.length) {
				const customise_init_keys = customise_init.map(c => { return c.value });
				const over = task_head_init.filter(head => { return !customise_init_keys.includes(head.value) });
				this.customise_view = [...customise_init, ...over];

				this.select_customise_view = this.customise_view.filter(head => {return head.showable === true });
			}
			if (customise_init.length > task_head_init.length) {
				const task_head_init_keys = task_head_init.map(c => { return c.value });
				this.customise_view = customise_init.filter(c => { return task_head_init_keys.includes(c.value) });

				this.select_customise_view = this.customise_view.filter(head => {return head.showable === true });
			}
		},
		typesInit() {
			this.select_types = this.typesInit;
		},
		viewOptionsInit() {
			this.select_view_options = this.viewOptionsInit;
		},
		select_status() {
			this.$emit('status', this.select_status);
		},
		select_customise_view() {
			const select_customise_view_keys = this.select_customise_view.map(s => { return s.value });

			const select_customise_view = [];
			this.customise_view.forEach(c => {
				if (select_customise_view_keys.includes(c.value)) {
					c.showable = true;
					select_customise_view.push(c);
				} else {
					c.showable = false;
					select_customise_view.push(c);
				}
			});

			this.$emit('customise-view', select_customise_view);
		},
		select_types() {
			this.$emit('type', this.select_types);
		},
		select_view_options() {
			this.$emit('options', this.select_view_options);
		},
	},
	computed: {
		isPrivilege() {
			let isPrivilege_tmp = false;
			const privileges = this.$store.state.privileges;
			if (privileges.includes(TR)) {
				isPrivilege_tmp = true;
			}

			return isPrivilege_tmp;
		},
		isItemPrivilege() {
			let isPrivilege_tmp = false;
			const privileges = this.$store.state.privileges;
			if (privileges.includes(CH)) {
				isPrivilege_tmp = true;
			}

			return isPrivilege_tmp;
		},
		isHolidaysPrivilege() {
			let isPrivilege_tmp = false;
			const privileges = this.$store.state.privileges;
			
			if (privileges.includes(DPubHol)) {
				isPrivilege_tmp = true;
			}

			return isPrivilege_tmp;
		},
		isColumnDiff() {
			let is_diff = false;

			if (this.customise_view.length !== this.select_customise_view.length) {
				is_diff = true;
			}

			return is_diff;
		}
	},
	methods: {
		onCreate() {
			let create_items = CREATE_ITEMS;
			if (!this.isPrivilege) {
				create_items = create_items.filter(c => {return c.value !== 'task'});
			}
			if (!this.isItemPrivilege) {
				create_items = create_items.filter(c => {return c.value !== 'item'});
			}
			if (!this.isHolidaysPrivilege) {
				create_items = create_items.filter(c => {return c.value !== 'holiday'});
			}

			this.$emit('create', create_items)
		},
		onChange() {
			this.$emit('customise-view', this.customise_view);
		}
	}
}
</script>
<style lang="scss" scoped>
.task-view {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 68px;
  background: #FFFFFF;
}
.task-view-items {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.checkbox-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
	width: 100%;
}
.checkbox-text-able {
 	color: #192A3E;
	 &:hover {
		 color: #81CC00;
	 }
}
.checkbox-text-disable {
 	color: #C4C4C4;
	&:hover {
		cursor: auto;
	}
}
.checkbox-text-hover {
	&:hover {
		cursor: pointer;
	}
}
.task-label {	
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	color: #FFFFFF;

}
.v-list--dense .v-list-item {
  min-height: 32px;
}
.tree-wrap {
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}

::v-deep {
	.v-input__control {
		min-height: 36px !important;
	}
	.v-input input::placeholder {
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 18px;
		color: #FFFFFF;
	}
	.v-text-field.v-text-field--solo .v-input__control input {
		padding-top: 0;
	}
}
</style>